import { UserRole } from 'gql/types';
import {
  ControlledDatePicker,
  ControlledInput,
  ControlledTextArea,
} from 'modules/common/components';
import { FormFieldWithComponent } from 'modules/common/types';
import UserSelect from 'modules/user/components/UserSelect';
import { getTranslation } from 'utils/getTranslation';

const t = getTranslation('donor.DvmExamForm');

export enum FormSectionFields {
  Veterinarian = 'veterinarian',
  AnimalName = 'animalName',
  ExaminationDate = 'examinationDate',
  Notes = 'notes',
  DonorId = 'donorId',
}

type FormFiledType = FormFieldWithComponent<
  FormSectionFields,
  { name: string }
>;

export const dvmExamFormFields: FormFiledType[] = [
  {
    name: FormSectionFields.Veterinarian,
    label: t(FormSectionFields.Veterinarian),
    Component: ({ control, name }) => (
      <UserSelect
        userRoles={[UserRole.Admin, UserRole.Dvm, UserRole.MedicalDirector]}
        controlled={{ control, name }}
        placeholder={t('selectVeterinarian')}
      />
    ),
  },
  {
    name: FormSectionFields.DonorId,
    label: t(FormSectionFields.DonorId),
    Component: ({ control, name }) => (
      <ControlledInput controlled={{ control, name }} disabled />
    ),
  },
  {
    name: FormSectionFields.AnimalName,
    label: t(FormSectionFields.AnimalName),
    Component: ({ control, name }) => (
      <ControlledInput controlled={{ control, name }} disabled />
    ),
  },
  {
    name: FormSectionFields.ExaminationDate,
    label: t(FormSectionFields.ExaminationDate),
    Component: ({ control, name }) => (
      <ControlledDatePicker
        controlled={{ control, name }}
        adjustDropdownPosition
      />
    ),
  },
  {
    name: FormSectionFields.Notes,
    label: t(FormSectionFields.Notes),
    Component: ({ control, name }) => (
      <ControlledTextArea
        controlled={{ control, name }}
        placeholder={t('enterNotes')}
      />
    ),
  },
];
